define(function (require) {
    "use strict";

    var _ = require('underscore');
    var I18n = require('i18n!nls/main');
    // var app = require('app/app');

    var MenuStructure = {
        sources: [],

        swapKeyToValue: function (json) {
            var ret = {};
            for (var key in json) {
                ret[json[key]] = key;
            }
            return ret;
        },

        getSources: function (newSources) {
            if (newSources && newSources.length) {
                this.sources = newSources;
            }

            this.setPositionsForSource();

            this.sources = this.sources.sort(function (a, b) {
                return a.position - b.position;
            });

            return this.sources;
        },
        setPositionsForSource: function () {
            var sourcesPositions = this.getSourcesPositions();

            if (!sourcesPositions.length) {
                return false;
            }

            this.sources.map(function (item) {
                if (sourcesPositions.get(item.id) === undefined) {
                    item.position = this.sources.length;
                    return;
                }

                if (sourcesPositions.get(item.id).get('position') === undefined) {
                    item.position = this.sources.length;
                    return;
                }

                item.position = sourcesPositions.get(item.id).get('position');

            }.bind(this));

            return true;
        },
        getSourcesPositions: function () {
            if (!app ||
                !app.Collections ||
                !app.Collections.StatisticSourcesPositions) {
                return [];
            }

            return app.Collections.StatisticSourcesPositions || [];
        },
        getCountNewLeads: function () {
            if (!app ||
                !app.Models ||
                !app.Models.LeftMenuCount) {
                return 0;
            }

            return app.Models.LeftMenuCount.get('leads_new') || 0;
        },
        getCountNewDeals: function () {
            if (!app ||
                !app.Models ||
                !app.Models.LeftMenuCount) {
                return 0;
            }

            return app.Models.LeftMenuCount.get('deals_new') || 0;
        },
        getMenu: function (newSources) {
            var sources = (newSources && newSources.length) ? this.getSources(newSources) : [];
            var countNewLeads = this.getCountNewLeads();
            var countNewDeals = this.getCountNewDeals();
            var countNewTasks = 0;
            // var project = app.Collections && app.Collections.Projects && app.Collections.Projects.get(app.currentProjectId);
            var search = app.Models.curProject.get('search') || [];
            var newStat = search.indexOf('view') >= 0;

            var partnerMenuLink = '/land/lk/partners.php';
            if(app.Models && app.Models.Account && app.Models.Account.get('new_partner') == 1){
                partnerMenuLink = '/land/lk/partners.php'
            }
            var structure = [];

            if (app.Models.Account.get('telephony_version') != 2) {
                var statSubMenu = [{
                    title: 'Статистика',
                    link: "#statistic"
                }, {
                    id: 'sources',
                    title: I18n.menu.my_adv_platform,
                    link: 'javascript:{}',
                    class: 'intro-step-2_8 js-sources-list',
                    subClass: 'intro-step-2_9',
                    submenu: sources
                }, {
                    title: I18n.menu.undefined_traffic,
                    link: '#statistic/source/unknown'
                }, {
                    title: I18n.menu.seo,
                    link: '#statistic/source/seo'
                }, {
                    title: I18n.menu.dinamic_conversion,
                    link: '#statistic/dynamics'
                }, {
                    title: I18n.menu.widgets_geolocation,
                    link: '#widgets/geolocation'
                }];

                if (newStat) {
                    statSubMenu = [{
                        title: 'Статистика',
                        link: "#statistic"
                    }, {
                        title: I18n.menu.dinamic_conversion,
                        link: '#statistic/dynamics'
                    }, {
                        title: I18n.menu.widgets_geolocation,
                        link: '#widgets/geolocation'
                    }, {
                        title: I18n.menu.crater,
                        link: '#crater'
                    }, {
                        title: I18n.menu.decomposition,
                        link: '#crater/decomposition'
                    }];
                }

                structure = [
                    {
                        title: I18n.menu.staff,
                        link: '#staff',
                        image: '/img/menu/staff.svg',
                        position: 0
                    }, {
                        id: 'crm',
                        title: I18n.menu.crm,
                        link: '#leads',
                        image: '/img/menu/crm.svg',
                        class: 'intro-step-4_0',
                        subClass: 'intro-step-4_1 intro-step-6_0 intro-step-7_0 intro-step-9_2',
                        position: 1,
                        submenu: [{
                            id: 'leads',
                            title: 'Лиды / Сделки',
                            link: '#leads',
                            icon: 'fa-calendar',
                            count: countNewLeads
                        }, {
                            title: I18n.menu.contacts,
                            link: '#contacts',
                            icon: 'fa-user'
                        }, {
                            title: I18n.menu.calendar,
                            link: '#calendar',
                            icon: 'fa-calendar-o'
                        }, {
                            title: I18n.menu.leads_buying,
                            link: '#leads/buying'
                        }, {
                            title: I18n.menu.autofunnel,
                            link: '#autofunnel'
                        }]
                    }, {
                        id: 'statistic',
                        title: I18n.menu.statistic,
                        link: '#',
                        image: '/img/menu/analytics.svg',
                        position: 2,
                        submenu: statSubMenu,
                    }, {
                        id: 'sites',
                        title: 'Конструктор',
                        link: '#sites',
                        image: '/img/menu/constructor.svg',
                        position: 3
                    }, {
                        id: 'callback',
                        title: I18n.menu.widgets,
                        link: '#',
                        image: '/img/menu/callback.svg',
                        class: 'intro-step-14_0',
                        position: 4,
                        submenu: [{
                            title: I18n.menu.callback_settings,
                            link: '#widgets/callback'
                        }, {
                            title: I18n.menu.offers,
                            link: '#widgets/offers'
                        }, {
                            id: 'vk_hunter',
                            title: I18n.menu.widgets_capture_user,
                            link: '#widgets/social'
                        }, {
                            title: I18n.menu.telephony_calltracking,
                            link: '#telephony/calltracking'
                        }]
                    }, {
                        id: 'virtual_pbx',
                        title: I18n.menu.telephony,
                        link: '#',
                        image: '/img/menu/pbx.svg',
                        position: 5,
                        submenu: [{
                            title: I18n.menu.telephony_numbers,
                            link: '#telephony/numbers'
                        }, {
                            title: I18n.menu.telephony_online,
                            link: '#telephony/online'
                        }, {
                            title: I18n.menu.telephony_offline,
                            link: '#telephony/offline'
                        }, {
                            title: I18n.menu.telephony_redirection,
                            link: '#telephony/redirection'
                        }, {
                            title: I18n.menu.telephony_comands,
                            link: '#telephony/comands'
                        }, {
                            title: I18n.menu.telephony_detail,
                            link: '#telephony/details'
                        }, {
                            title: I18n.menu.telephony_robot,
                            link: '#telephony/robot'
                        }, {
                            title: I18n.menu.telephony_welcome,
                            link: '#telephony/welcome'
                        }, {
                            title: I18n.menu.telephony_simcards,
                            link: '#telephony/simcards'
                        }, {
                            title: I18n.menu.widgets_blacklist,
                            link: '#widgets/blacklist'
                        }]
                    }, {
                        title: 'Чат',
                        link: '#chat',
                        icon: 'fa-comments',
                        position: 6
                    }, {
                        id: 'services',
                        title: I18n.menu.services,
                        link: '#',
                        icon: 'fa-shopping-bag',
                        position: 11,
                        submenu: [{
                            title: I18n.menu.services_order,
                            link: '#',
                            submenu: [{
                                title: I18n.menu.services_all_services,
                                link: '#services/services'
                            }]
                        }, {
                            title: I18n.menu.services_exec,
                            link: '#',
                            submenu: [{
                                title: I18n.menu.services_all_orders,
                                link: '#services/orders'
                            }]
                        }, {
                            title: I18n.menu.services_moderation,
                            link: '#services/moderation'
                        }]
                    }, {
                        title: app.Models.Account.get('new_partner') ? 'Партнерство' : 'Реферальная программа',
                        fixed: true,
                        link: partnerMenuLink,
                        image: '/img/menu/partners.svg',
                        class: 'menu_partners',
                        position: 12
                    },
                    {
                        title: I18n.menu.settings,
                        fixed: false,
                        link: '#settings',
                        image: '/img/menu/set.svg',
                        position: 13,
                        submenu: [{
                            title: I18n.menu.general_settings,
                            link: '#settings'
                        }, {
                            title: I18n.menu.edit_steps,
                            link: '#crater/edit_steps'
                        }, {
                            title: I18n.menu.constructor,
                            link: '#constructor'
                        }, {
                            title: I18n.menu.import,
                            link: '#leads/import'
                        }, {
                        //     title: I18n.menu.import_deals,
                        //     link: '#deals/import',
                        // }, {
                            title: I18n.menu.smsSenderNames,
                            link: '#sms-sender-names'
                        }]
                    }
                ];

            } else {
                var map = {};
                var menu = _.reject(_.sortBy(app.menu, 'order'), function(item) {
                    if (item.url) {
                        item.url = item.url.replace(/\$\{[\w\.]*\}/g, function(valname) {
                            let path = valname.substring(2, valname.length-1).split('.');
                            let value = app.Models[path[0]].get(path[1]);

                            return value || '';
                        })
                    }

                    return (item.account_id && item.account_id != app.AUTH_ID);
                });

                for(var i = 0, len = menu.length; i < len; i++) {
                    map[menu[i].id] = JSON.parse(JSON.stringify(menu[i]));
                    map[menu[i].id]['submenu'] = [];
                }


                for (var id in map) {
                    if (map[id].parent_id) {
                        if ( map[map[id].parent_id]) {
                            map[map[id].parent_id]['submenu'].push(map[id]);
                        }
                    } else {
                        structure.push(map[id]);
                    }
                }

                const refLink = {
                    name: app.Models.Account.get('new_partner') ? 'Партнерство' : 'Реферальная программа',
                    fixed: true,
                    url: partnerMenuLink,
                    icon: 'https://my.lptracker.ru/land/id/images/menu/part_0.svg',
                    class: 'menu_partners',
                    position: 12
                };

                if(app.Models.User.get('product'))
                {
                    if(app.Models.User.get('product').options['referral']) {
                        structure.push(refLink)
                    }
                } else {
                    structure.push(refLink)
                }
            }

            return structure;
        }
    };

    return MenuStructure;
});
